<template>
    <section>
        <transition-group name="modal">
            <div id="editPlanoName" class="modal-mask" key="editPlanoName" @click="close">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody" @click.stop>
                            <div class="_container_ rel">
                                <img src="../../../assets/croix.png" width="20" height="20" alt @click="close" class="cross fright abs pointer" />

                                <section class="fd-r fw-w m-jc-sb">
                                    <div class="flexContainer fd-c ai-c jc-fs">
                                        <div class="flexContainer fd-c">
                                            <label class="full ff-medium fleft labelName">{{ $t("plano.enter_new_name") }}</label>
                                            <input name class="full planoName mt10" v-model="name" :placeholder="$t('plano.name_placeholder')" />
                                        </div>
                                        <div id="content">
                                            <p class="ff-light flexContainer fd-r jc-c">
                                                <button class="btn_validate pointer" @click="save();">{{ $t("plano.btn_validate") }}</button>
                                            </p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>
<script>
import "whatwg-fetch";
import httpService from "@/components/service";
import { mapGetters } from "vuex";

export default {
    props: { currentPlanoName: String },
    data: () => ({ name: "" }),
    watch: {
        currentPlanoName(value) {
            this.name = value;
        }
    },
    methods: {
        save() {
            this.nullName = false;
            if (this.name === null || this.name === "") {
                this.nullName = true;
                return true;
            }
            this.$emit("close", this.name);
        },
        close() {
            this.$emit("close");
        }
    },
    computed: {
        ...mapGetters({
            getResults: "planos/search/getResults"
        })
    },
    mounted() {
        this.name = this.currentPlanoName;

        this.listener = e => {
            if (e.keyCode === 27) {
                this.close();
            }
        };
        document.addEventListener("keydown", this.listener);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.listener);
    }
};
</script>

<style lang="scss" scoped>
.titles {
    text-transform: uppercase;
    font-family: Roboto, Sans-Serif;
}
.note {
    font-family: Roboto, Sans-Serif;
    position: absolute;
    bottom: 50px;
    font-size: 10px;
    padding: 0 60px;
    font-weight: bold;
    text-align: justify;
}
._rem3rch_color {
    color: #41b4e8;
}
._result {
    position: absolute;
    padding-top: 40px;
    border-radius: 3px;
    top: 0;
    left: 0;
    height: calc(100%);
    width: 100%;
    background-color: white;
    z-index: 20;
    // border: 1px solid black;
    font-size: 200%;
}
.planoName {
    padding: 0.5em;
    font-size: 1.2em;
    border: none;
    border-bottom: 2px solid #333;
    width: 300px;
}
.brandLogo {
    cursor: hand;
}
label {
    font-size: 1.4rem;
    color: darkgray;
}
.btn_validate,
.btn_open_plano {
    border-radius: 2em;
    padding: 6px 10px;
    background: white;
    border: 1px solid black;
}
._container_ {
    padding: 20px;
    background-color: white;
    position: relative;
    border-radius: 4px;
    .cross {
        top: -10px;
        right: -10px;
        z-index: 25;
    }
}
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 650px;
            .brandLogo:hover {
                background-color: #41b4e8;
                color: white;
            }
            .brandLogo {
                border-radius: 0.5rem;
                font-size: 12px;
                background-color: #f4f4f4;
                /* padding: 2px; */
                width: 130px;
                height: 40px;
                line-height: 40px;
                -webkit-margin-before: 0;
                -webkit-margin-after: 0;
                -webkit-margin-start: 0px;
                -webkit-margin-end: 0px;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            margin: auto;
            .brandWrap {
                margin: 2px;
            }
            p {
                font-family: Roboto;
                font-size: 1.4rem;
            }
            .danger {
                font-size: 1.2rem;
            }
        }
    }
}
@media only screen and (max-width: 767px) {
    .modal-wrapper {
        .modal-container {
            .logoContainer {
                width: auto;
                padding-left: 15px;
                padding-right: 15px;
            }
        }
        #content {
            height: calc(100vh - 180px);
            overflow-y: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditNameModal.vue?615b4be6